import * as types from './mutationTypes'

export default {
  [types.SET_CURRENT_USER] (state, user) {
    if (user && user.membership) {
      // ensure user with membership does not have to re-enter code
      state.hasMembershipAccess = true
    }
    state.currentUser = user
  },
  [types.SET_USER_TOKEN] (state, token) {
    state.userToken = token
  },
  [types.SET_HAS_MEMBERSHIP_ACCESS] (state, access) {
    state.hasMembershipAccess = access
  },
  [types.SET_SELECTED_MEMBERSHIP_TYPE] (state, membershipType) {
    state.selectedMembershipType = membershipType
  },
  [types.ADD_INVITE_CODE] (state, inviteCode) {
    state.inviteCodes = [
      ...new Set([
        ...state.inviteCodes,
        inviteCode,
      ])
    ]
  },
  [types.SET_INVITE_CODES] (state, inviteCodes) {
    state.inviteCodes = inviteCodes ? [...new Set(inviteCodes)] : null
  },
  // Payment
  [types.SET_SQUARE_STATUS] (state, status) {
    state.squareStatus = status
  },
  [types.SET_STRIPE_STATUS] (state, status) {
    state.stripeStatus = status
  },

  // Utility functions
  [types.SET_MESSAGE] (state, message) {
    state.message = message
  },
  [types.SET_IS_LOADING] (state, loading) {
    state.isLoading = loading
  },
  [types.SET_IS_ERROR] (state, error) {
    state.isError = error
  },
  [types.SET_LAST_ERROR] (state, error) {
    state.lastError = error
  },

  [types.SET_TICKETS_URI] (state, uri) {
    state.ticketsUri = uri
  },
  [types.SET_HIDE_UPGRADE_WALL] (state, hide) {
    // hide for 10 seconds on dev or for 1 day on other envs
    const hideForMillis = process.env.NODE_ENV == "development" ? 10*1000 : 1*24*3600*1000;
    state.hideUpgradeWallUntil = hide ? (new Date()).getTime() + hideForMillis : null;
  },
  [types.SET_HIDE_ACTION_REQUIRED] (state, hide) {
    // hide for 10 seconds on dev or for 1 day on other envs
    state.hideActionRequired = hide;
  },
  [types.SET_SELECTED_MEMBERSHIP_COUPON] (state, coupon) {
    state.membershipCoupon = coupon
  },
  [types.SET_PRESET_COUPON_CODE] (state, presetCouponCode) {
    state.presetCouponCode = presetCouponCode
  },
  [types.SET_MEMBERSHIP_SCAN_PENDING] (state, membershipScanPending) {
    state.membershipScanPending = membershipScanPending
  },
}